import { render, staticRenderFns } from "./ConsumptionDataExchangeVarysMDL.vue?vue&type=template&id=3bb97a5a&lang=pug&"
import script from "./ConsumptionDataExchangeVarysMDL.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeVarysMDL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports